import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import { Button, Table } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import { getSettingByQuery } from '../../../services/setting.service';
import TagExercise from '../../../components/tags/TagExercise';
import { getAccountById } from '../../../services/user.service';
import { getIdToken } from 'firebase/auth';
import { getExerciseById } from '../../../services/exercise.service';
import { useTranslation } from 'react-i18next';
import { capitalize } from '../../../utils/utils';

const Settings = (props) => {
  const { user } = useContext(Auth);
  const params = useParams();
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (user.account) {
      loadSettings(params.account);
      loadAccount(params.account);
    }
  }, [user.account]);

  const loadSettings = async (userId) => {
    const { status, data } = await getSettingByQuery({ account: userId, isActive: true }, user.token);
    if (status === 200) {
      const settingsArr = [];
      for await (const setting of data.data) {
        const isActive = await loadExercise(setting.exercise);
        setting.key = setting._id;
        if (isActive) {
          settingsArr.push(setting);
        }
      }
      setSettings(settingsArr);
      setLoading(false);
    }
  };

  const loadExercise = async (exerciseId) => {
    const { status, data } = await getExerciseById(exerciseId, user.token);
    if (status === 200 && data.data.isActive) {
      return true;
    }
    return false;
  };

  const loadAccount = async (userId) => {
    const { status, data } = await getAccountById(userId, user.token);
    if (status === 200) {
      setAccount(data.data);
    }
  };

  const columns = [
    {
      title: capitalize(t('settings')),
      // dataIndex: ['name', 'surname', 'email', 'phone'],
      key: 'all',
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          <TagExercise key={record?.exercise} id={record?.exercise} user={user} />
          <br />
          {record.weight ? record.weight.toFixed(2) : capitalize(t('isometric'))}
          <br />
          {record.setting}
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 5
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('exercise')),
      key: 'exercise',
      render: (record) => (
        <React.Fragment>
          <TagExercise key={record?.exercise} id={record?.exercise} user={user} />
        </React.Fragment>
      ),
      responsive: ['sm']
    },
    {
      title: capitalize(t('recommendedWeight')),
      key: 'weight',
      // eslint-disable-next-line react/display-name
      render: (record) => record.weight ? record.weight.toFixed(2) : capitalize(t('isometric')),
      responsive: ['sm']
    },
    {
      title: capitalize(t('settings')),
      key: 'settings',
      // eslint-disable-next-line react/display-name
      render: (record) => record.setting,
      responsive: ['sm']
    }
  ];

  function onChange (pagination, filters, sorter, extra) {

  }

  if (loading) {
    return (
      <Spinner/>
    );
  } else {
    return (
      <>
        <Button type="primary" shape="round" icon={<PlusOutlined />} size='large' onClick={() => navigate('add')} style={{ marginBottom: 18 }}>
          {capitalize(t('createNewSetting'))}
        </Button>
        <div>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <b>{account ? account.name + ' ' + account.surname : ''}</b>
        </div>
        <Table columns={columns} dataSource={settings} onChange={onChange} onRow={(record, rowIndex) => {
          return {
            onClick: event => { navigate('/dashboard/users/settings/edit/' + record._id); }, // click row
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {} // mouse leave row
          };
        }} rowClassName={'row-pointer'}
        />
        <br />
      </>
    );
  };
};

export default Settings;
